import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { updateIndividualArea } from '../../actions/individualAreas';
import { handleError, handleSuccess, handleWarning } from '../../helpers/utils';

export const IndividualAreaForm = ({ open, handleClose, area, refresh }) => {
	const [days, setDays] = React.useState('');

	const handleSave = () => {
		if (days >= 1) {
			updateIndividualArea(area.id, {
				...area,
				days,
			})
				.then(() => {
					handleSuccess('Área actualizada');
					refresh();
					handleClose();
				})
				.catch((error) => {
					handleError(error, 'No se pudo actualizar el área');
				});
		} else {
			handleWarning(
				'Los días autorizados deben ser mayores o iguales a 1'
			);
		}
	};

	return (
		<Dialog open={open} onClose={handleClose} maxWidth='xs'>
			{area && (
				<>
					{' '}
					<DialogTitle>{area.name}</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Cambiar días autorizados.
						</DialogContentText>
						<TextField
							autoFocus
							margin='normal'
							id='days'
							label='Días autorizados'
							type='number'
							fullWidth
							variant='standard'
							value={days}
							onChange={({ target }) => {
								setDays(target.value);
							}}
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleClose}>Cancelar</Button>
						<Button onClick={handleSave}>Guardar</Button>
					</DialogActions>
				</>
			)}
		</Dialog>
	);
};
